import React from 'react';
import type { ChatSession } from '../types/chat';

type SidebarProps = {
  chats: ChatSession[];
  activeChatId: string | null;
  onNewChat: () => void;
  onSelectChat: (chatId: string) => void;
};

const Sidebar: React.FC<SidebarProps> = ({ chats, activeChatId, onNewChat, onSelectChat }) => {
  return (
    <aside className="w-full md:w-64 bg-slate-950 border-r border-slate-800 p-4 flex flex-col gap-4">
      <button
        className="w-full rounded-xl border border-slate-700 bg-slate-900 px-3 py-2 text-sm font-semibold text-slate-100 hover:bg-slate-800"
        onClick={onNewChat}
      >
        + New Chat
      </button>

      <div className="flex-1 overflow-y-auto space-y-2">
        {chats.map((chat) => (
          <button
            key={chat.id}
            className={`w-full text-left rounded-lg px-3 py-2 text-sm ${
              chat.id === activeChatId
                ? 'bg-slate-800 text-white'
                : 'text-slate-300 hover:bg-slate-900'
            }`}
            onClick={() => onSelectChat(chat.id)}
          >
            {chat.title || 'New chat'}
          </button>
        ))}
      </div>
    </aside>
  );
};

export default Sidebar;
